export default __webpack_public_path__ + "static/media/Manual-7.c9639947.png";